// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { UsersList } from 'features/users/components';
import { useOrganizationAdminsInfiniteQuery } from '../../../queries';

type P = {
  organizationId: string;
};

const OrganizationAdminsList = ({ organizationId }: P) => {
  const {
    data: administrators,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
  } = useOrganizationAdminsInfiniteQuery({ filter: { organizationId }, pagination: { pageSize: 10 } });

  const allAdministrators = administrators?.pages.flatMap((administratorsPaginated) => administratorsPaginated.data);

  return (
    <UsersList
      queryData={{
        fetchNextPage,
        hasNextPage,
        isFetching,
        isLoading,
      }}
      users={allAdministrators}
    />
  );
};

export default OrganizationAdminsList;
